(() => {
  'use strict';
  if (customElements.get('rl-fit-demo')) return;

  class RLFitDemo extends HTMLElement {
    constructor() {
      super();
      this.turns = 0;
      this.turnTimer = null;
      this.observer = null;
      this.listeners = null;
    }

    connectedCallback() {
      if (this.listeners) return;
      this.listeners = new AbortController();
      this.renderState();
      this.querySelector('[data-rl-fit-photo]')?.addEventListener('load', () => {
        this.syncPhoto();
      }, { signal: this.listeners.signal });
      this.syncPhoto();
      this.addEventListener('click', (event) => {
        if (!(event.target instanceof Element)) return;
        const button = event.target.closest('[data-rl-fit-turn]');
        if (!button || button.closest('rl-fit-demo') !== this) return;
        this.turns += 1;
        this.dataset.engaged = 'true';
        this.renderState();
        clearTimeout(this.turnTimer);
        this.classList.add('is-turning');
        this.turnTimer = setTimeout(() => {
          this.classList.remove('is-turning');
          this.turnTimer = null;
        }, 500);
      }, { signal: this.listeners.signal });

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          if (this.observer !== observer || !this.isConnected) return;
          const entry = entries.find((item) => item.target === this);
          if (entry) {
            this.dataset.inView = String(entry.isIntersecting);
            if (entry.isIntersecting) this.syncPhoto();
          }
        });
        this.observer = observer;
        observer.observe(this);
      } else {
        this.dataset.inView = 'true';
      }

      this.dataset.ready = 'true';
    }

    disconnectedCallback() {
      this.listeners?.abort();
      this.listeners = null;
      clearTimeout(this.turnTimer);
      this.turnTimer = null;
      this.observer?.disconnect();
      this.observer = null;
      this.classList.remove('is-turning');
      delete this.dataset.ready;
      delete this.dataset.inView;
    }

    syncPhoto() {
      const photo = this.querySelector('[data-rl-fit-photo]');
      const face = this.querySelector('[data-rl-fit-face-image]');
      if (!photo || !face || !photo.complete || photo.naturalWidth <= 0) return;
      const source = photo.currentSrc || photo.src;
      if (source && face.getAttribute('href') !== source) face.setAttribute('href', source);
    }

    renderState() {
      const step = Math.min(this.turns, 3);
      const message = this.turns === 0
        ? this.dataset.messageInitial || ''
        : this.turns === 1 ? this.dataset.messageOnce || '' : (this.dataset.messageMany || '').replace('__COUNT__', String(this.turns));
      this.dataset.state = String(step);
      this.style.setProperty('--rl-fit-step', String(step));
      this.style.setProperty('--rl-fit-angle', `${this.turns * 60}deg`);
      this.querySelectorAll('[data-rl-fit-turn]').forEach((button) => {
        button.removeAttribute('disabled');
        button.removeAttribute('aria-disabled');
      });
      this.querySelectorAll('[data-rl-fit-status]').forEach((status) => { status.textContent = message; });
    }
  }

  customElements.define('rl-fit-demo', RLFitDemo);
})();
